import React from "react";
import { useNavigate } from "react-router-dom";

import { useCatalogueContext } from "../../contexts/CatalogueContext/CatalogueContext";
import "./ErrorBoundaryPage.scss";

const ErrorBoundaryPage: React.FC = () => {
	const { state: errorMessage } = useCatalogueContext((state) => state.errorMessage);
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate("/");
	};

	return (
		<div className="ErrorBoundaryPage">
			<h1 className="ErrorTitle">Oops! Something went wrong.</h1>
			<div className="ErrorMessage">{errorMessage}</div>
			<button className="GoHomeButton" onClick={handleGoHome}>
				Go Back to Home
			</button>
		</div>
	);
};

export default ErrorBoundaryPage;
